import "./App.css";
import React, { useRef, useState, useEffect } from "react";
import Hero from "./assets/top-view-workspace-with-notepad-copy-space.jpg";
import Darlan from "./assets/Darlan.png";
import Isa from "./assets/Isa.png";
import Fada from "./assets/Fada.png";
import Branding from "./assets/Branding.png";
import Estilize from "./assets/Estilze.png";
import Pino from "./assets/DF.PNG";
import Leomar from "./assets/Leomar.png";
import Group from "./assets/group.png";
import Savale from "./assets/savale.png";
import logo from "./assets/Simbulo.png";
import Divino from "./assets/Selo.png";
import emailjs from "emailjs-com";
import Header from "./Conponentes/Header";
import ASM from "./assets/ASM.png";
import AOS from "aos";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import {
  FaInstagram,
  FaWhatsapp,
  FaMapMarkerAlt,
  FaChartLine,
  FaFileInvoiceDollar,
  FaRegLightbulb,
  FaUsers,
  FaBalanceScale,
  FaShieldAlt,
  FaRocket,
  FaBook,
  FaUsersCog,
} from "react-icons/fa";

export default function App() {
  const form = useRef();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_oy8n6y5",
        "template_hqia079",
        form.current,
        "3ZNn1Wm8YtupNsSu0",
      )
      .then(
        () => {
          alert("Mensagem enviada com sucesso!");
        },
        (error) => {
          alert("Erro ao enviar mensagem: " + error.text);
        },
      );
  };

  return (
    <div className="min-h-screen bg-gray-50 text-gray-800 font-sans">
      <a
        href="https://wa.me/5551999777981"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed z-100 bottom-10 right-4 inline-flex items-center px-6 py-3 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-white font-semibold rounded-full shadow-lg hover:scale-105 transition-transform duration-300"
      >
        <FaWhatsapp className="w-6 h-6 mr-2" />
        Fale Conosco no WhatsApp
      </a>
      <Header isOpen={isOpen} setIsOpen={setIsOpen} />

      <section className="h-screen grid md:grid-cols-1 text-white relative bg-gradient-to-br from-gray-900 via-black to-gray-800 overflow-hidden">
        <img
          src={Hero}
          alt="Background empresarial"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/40 to-transparent"></div>

        <motion.div
          initial={{ x: -200, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="relative z-10 flex flex-col items-start text-left gap-8 px-4 sm:px-8 md:px-20 justify-center min-h-screen"
        >
          <motion.h2
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0 }}
            className="text-4xl sm:text-5xl md:text-7xl font-bold tracking-tight leading-tight font-sans"
          >
            <span className="text-white">Elo</span>{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Soluções Empresariais
            </span>
          </motion.h2>

          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
            className="w-20 sm:w-24 h-1 bg-[#956930] rounded-full"
          ></motion.div>

          <motion.h3
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.4 }}
            className="text-xl sm:text-2xl md:text-3xl text-gray-300 font-serif italic max-w-xl"
          >
            Inovação que conecta resultados
          </motion.h3>

          <motion.p
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.6 }}
            className="leading-relaxed text-base sm:text-lg md:text-xl font-light max-w-xl text-gray-400"
          >
            Gestão contábil e financeira com{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent font-semibold">
              transparência
            </span>{" "}
            e{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent font-semibold">
              inovação
            </span>
            .{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent font-medium italic">
              Parceiros estratégicos para o sucesso da sua empresa
            </span>
          </motion.p>

          <motion.div
            initial={{ x: -200, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 1, ease: "easeOut", delay: 0.8 }}
            className="mt-6"
          >
            <a
              href="https://wa.me/5551999777981"
              className="px-5 sm:px-6 py-3 bg-[#956930] text-black font-semibold rounded-lg shadow-lg hover:opacity-90 transition-all duration-300"
            >
              Fale Conosco
            </a>
          </motion.div>
        </motion.div>
      </section>

      <section
        id="servicos"
        className="py-16 px-[10%] bg-gradient-to-r from-black via-gray-900 to-black text-white space-y-20"
      >
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold mb-3 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Serviços
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Soluções contábeis modernas para apoiar o crescimento da sua empresa
            com experiência, tecnologia e transparência.
          </p>
        </div>

        <div
          className="grid md:grid-cols-2 gap-8 items-center"
          data-aos="flip-left"
        >
          <div className="flex flex-col items-center justify-center h-full text-center">
            <h3 className="text-2xl font-bold mb-3 flex items-center gap-2 justify-center">
              <span className="w-2 h-6 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] inline-block rounded"></span>
              Estruturação e Regularização de Empresas
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Análise e enquadramento societário e tributário;</li>
              <li>Estruturação de Holdings e Offshores;</li>
              <li>
                Registro em órgãos competentes (Junta, Receita, Prefeitura
                etc.).
              </li>
            </ul>
          </div>
          <div className="flex justify-center">
            <FaBalanceScale className="h-16 w-16 text-[#cea664]" />
          </div>
        </div>

        <div
          className="grid md:grid-cols-2 gap-8 items-center"
          data-aos="flip-right"
        >
          <div className="flex justify-center">
            <FaBook className="h-16 w-16 text-[#cea664]" />
          </div>
          <div className="flex flex-col items-center justify-center h-full text-center">
            <h3 className="text-2xl font-bold mb-3 flex items-center gap-2 justify-center">
              <span className="w-2 h-6 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] inline-block rounded"></span>
              Contabilidade Gerencial e Fiscal
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Escrituração contábil e fiscal;</li>
              <li>Apuração e envio de tributos;</li>
              <li>Relatórios e demonstrativos gerenciais;</li>
              <li>Acompanhamento de indicadores de desempenho;</li>
              <li>Atendimento consultivo e personalizado.</li>
            </ul>
          </div>
        </div>

        <div
          className="grid md:grid-cols-2 gap-8 items-center"
          data-aos="flip-left"
        >
          <div className="flex flex-col items-center justify-center h-full text-center">
            <h3 className="text-2xl font-bold mb-3 flex items-center gap-2 justify-center">
              <span className="w-2 h-6 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] inline-block rounded"></span>
              Soluções para Folha de Pagamento
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Cálculo da folha de salários;</li>
              <li>
                Emissão de guias trabalhistas (e-Social, FGTS, INSS etc.);
              </li>
              <li>Gestão de férias, 13º salário e rescisões;</li>
              <li>Suporte completo na rotina trabalhista empresarial.</li>
            </ul>
          </div>
          <div className="flex justify-center">
            <FaUsersCog className="h-16 w-16 text-[#cea664]" />
          </div>
        </div>

        <div
          className="grid md:grid-cols-2 gap-8 items-center"
          data-aos="flip-right"
        >
          <div className="flex justify-center">
            <FaChartLine className="h-16 w-16 text-[#cea664]" />
          </div>
          <div className="flex flex-col items-center justify-center h-full text-center">
            <h3 className="text-2xl font-bold mb-3 flex items-center gap-2 justify-center">
              <span className="w-2 h-6 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] inline-block rounded"></span>
              Consultoria Empresarial
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Diagnóstico financeiro e organizacional;</li>
              <li>Estruturação de processos e rotinas;</li>
              <li>Apoio ao planejamento estratégico;</li>
              <li>Identificação de melhorias e redução de custos;</li>
              <li>Acompanhamento na implementação de mudanças.</li>
            </ul>
          </div>
        </div>

        <div
          className="grid md:grid-cols-2 gap-8 items-center"
          data-aos="flip-left"
        >
          <div className="flex flex-col items-center justify-center h-full text-center">
            <h3 className="text-2xl font-bold mb-3 flex items-center gap-2 justify-center">
              <span className="w-2 h-6 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] inline-block rounded"></span>
              Respaldo Tributário para Pessoas Físicas
            </h3>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>Apuração de ganhos com criptoativos;</li>
              <li>
                Suporte tributário para investimentos no Brasil e no exterior;
              </li>
              <li>Apuração de GCAP, Carnê-Leão, IRPF;</li>
              <li>
                Orientação para regularidade fiscal e prevenção de autuações.
              </li>
            </ul>
          </div>
          <div className="flex justify-center">
            <FaFileInvoiceDollar className="h-16 w-16 text-[#cea664]" />
          </div>
        </div>
      </section>

      <section
        id="apresentacao"
        className="py-20 px-20 bg-gradient-to-r from-black via-gray-900 to-black text-white"
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">
            Por que escolher a{" "}
            <span className="bg-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Elo
            </span>
            ?
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Conheça os diferenciais que tornam nossa parceria estratégica para o
            sucesso da sua empresa.
          </p>
        </div>

        <div className="grid md:grid-cols-5 lg:grid-cols-5 gap-10">
          <div
            className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black rounded-xl shadow-lg p-8 flex flex-col items-start text-left hover:scale-105 transition-transform duration-500"
            data-aos="flip-left"
          >
            <FaRegLightbulb size={32} className="mb-4 text-black" />
            <h3 className="text-lg font-bold mb-2">Soluções Personalizadas</h3>
            <p className="text-sm">
              Soluções sob medida que geram valor duradouro para o seu negócio.
            </p>
          </div>

          <div
            className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black rounded-xl shadow-lg p-8 flex flex-col items-start text-left hover:scale-105 transition-transform duration-500"
            data-aos="flip-right"
          >
            <FaUsers size={32} className="mb-4 text-black" />
            <h3 className="text-lg font-bold mb-2">
              Profissionais Experientes
            </h3>
            <p className="text-sm">
              Equipe qualificada e em constante atualização para atender suas
              demandas.
            </p>
          </div>

          <div
            className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black rounded-xl shadow-lg p-8 flex flex-col items-start text-left hover:scale-105 transition-transform duration-500"
            data-aos="flip-left"
          >
            <FaBalanceScale size={32} className="mb-4 text-black" />
            <h3 className="text-lg font-bold mb-2">Eficiência Operacional</h3>
            <p className="text-sm">
              Foco na redução de custos e otimização tributária para sua
              empresa.
            </p>
          </div>

          <div
            className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black rounded-xl shadow-lg p-8 flex flex-col items-start text-left hover:scale-105 transition-transform duration-500"
            data-aos="flip-right"
          >
            <FaShieldAlt size={32} className="mb-4 text-black" />
            <h3 className="text-lg font-bold mb-2">Integridade</h3>
            <p className="text-sm">
              Condução de todas as etapas com ética e transparência.
            </p>
          </div>

          <div
            className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black rounded-xl shadow-lg p-8 flex flex-col items-start text-left hover:scale-105 transition-transform duration-500"
            data-aos="flip-left"
          >
            <FaRocket size={32} className="mb-4 text-black" />
            <h3 className="text-lg font-bold mb-2">Respostas Rápidas</h3>
            <p className="text-sm">
              Agilidade e soluções eficazes para suas necessidades empresariais.
            </p>
          </div>
        </div>
      </section>

      <section
        id="equipe"
        className="py-20 bg-gradient-to-r from-black via-gray-900 to-black text-white"
      >
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Nossa Equipe
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            Conheça o grupo de profissionais que faz a Elo Soluções Empresariais
            ser referência em transparência, inovação e dedicação ao crescimento
            da sua empresa
          </p>
        </div>

        <div className="flex flex-col items-center gap-10">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-8 justify-items-center">
            <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl shadow-xl p-6 text-center w-full max-w-xs transform transition-transform duration-300">
              <img
                src={Darlan}
                alt="Gerente"
                className="w-42 object-cover  mx-auto mb-4 border-4 border-[#cea664] shadow-md"
              />
              <h3 className="text-lg font-semibold text-[#cea664]">
                Darlan M.
              </h3>
              <p className="text-sm text-gray-300 italic">
                Sócio Administrador
              </p>
              <a
                href="mailto:darlan@empresa.com"
                className="text-sm block mt-2"
              >
                elocontabilcont1@gmail.com
              </a>
            </div>

            <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-xl shadow-xl p-6 text-center w-full max-w-xs transform transition-transform duration-300">
              <img
                src={Isa}
                alt="Gerente"
                className="w-42   object-cover  mx-auto mb-4 border-4 border-[#cea664] shadow-md"
              />
              <h3 className="text-lg font-semibold text-[#cea664]">
                Isabella C.
              </h3>
              <p className="text-sm text-gray-300 italic">
                Sócio Administrador
              </p>
              <a
                href="mailto:isabella@empresa.com"
                className="text-sm block mt-2"
              >
                elocontabilfinanceiro@gmail.com
              </a>
            </div>
          </div>
          <br />

          
        </div>
      </section>

      <section
        id="instagram"
        className="py-20 bg-gradient-to-r from-black via-gray-900 to-black text-white"
      >
        <div className="max-w-4xl mx-auto text-center px-6">
          <FaInstagram className="text-[#cea664] text-6xl mx-auto mb-6" />

          <h2 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Acompanhe a Elo no Instagram
          </h2>

          <p className="max-w-2xl mx-auto mb-8 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Fique por dentro das novidades, dicas de gestão financeira e
            conteúdos exclusivos que vão ajudar sua empresa a crescer com
            transparência e inovação.
          </p>

          <a
            href="https://www.instagram.com/elosolucoesempresariais?igsh=MTN5eWU4Y3dqOXJleg%3D%3D&utm_source=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-black font-semibold px-8 py-3 rounded-lg shadow-md hover:bg-amber-500 transition-colors duration-300"
          >
            Seguir no Instagram
          </a>
        </div>
      </section>

      <section
        id="parceiros"
        className="py-20 px-[8%] bg-gradient-to-r from-black via-gray-900 to-black text-white"
      >
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4 bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Nossos Parceiros
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed">
            Trabalhamos lado a lado com empresas líderes que compartilham nossos
            valores de{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent font-semibold">
              excelência
            </span>{" "}
            e{" "}
            <span className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent font-semibold">
              inovação
            </span>
            , criando conexões estratégicas para o crescimento sustentável.
          </p>
        </div>

        <div className="grid md:grid-cols-3 lg:grid-cols-3  m-auto gap-2">
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Fada} alt="Amazon" className="logo-img mb-4" />
            <h3 className="text-lg text-center font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Fáda Dos Florais
            </h3>
          </div>

          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Branding} alt="Apple" className="logo-img mb-4" />
            <h3 className="text-lg text-center font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Branding Que comunica
            </h3>
          </div>

          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Group} alt="Google" className="logo-img mb-4" />
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              CVA Group Distribuidora
            </h3>
          </div>
        </div>
        <div className="grid md:grid-cols-3 lg:grid-cols-3  m-auto gap-2 pt-2">
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Pino} alt="Microsoft" className="logo-img mb-4" />
            <h3 className="text-lg text-center font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              DF & K Mecânica Automotiva
            </h3>
          </div>
          <div className="bg-gradient-to-b  from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Savale} alt="Google" className="logo-img mb-4" />
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Savale Imóveis
            </h3>
          </div>

          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Estilize} alt="Google" className="logo-img mb-4" />
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Estilize Móveis
            </h3>
          </div>
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Divino} alt="Amazon" className="logo-img mb-4" />
            <h3 className="text-lg text-center font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Divino Vestido
            </h3>
          </div>

          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={Leomar} alt="Google" className="logo-img mb-4" />
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              Leomar Hortifruti
            </h3>
          </div>
          <div className="bg-gradient-to-b from-gray-800 to-gray-900 border border-[#cea664] rounded-2xl shadow-lg p-8 flex flex-col items-center transform  hover:shadow-amber-500/30 transition duration-300">
            <img src={ASM} alt="Google" className="logo-img mb-4" />
            <h3 className="text-lg font-bold bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
              ASM Facilities
            </h3>
          </div>
        </div>
      </section>

      <section className="bg-gradient-to-r from-black via-gray-900 to-black py-16 text-white">
        <div className="max-w-4xl mx-auto px-6">
          <h2 className="text-3xl font-bold mb-6 text-center bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] bg-clip-text text-transparent">
            Entre em Contato
          </h2>
          <p className="text-lg text-gray-300 mb-10 text-center max-w-2xl mx-auto">
            Preencha o formulário abaixo e nossa equipe retornará o contato por
            e-mail o mais rápido possível.
          </p>

          <form
            ref={form}
            onSubmit={sendEmail}
            className="bg-gray-800 shadow-lg rounded-lg p-8 space-y-6"
          >
            <div>
              <label className="block text-gray-300 font-semibold mb-2">
                Nome
              </label>
              <input
                type="text"
                name="user_name"
                placeholder="Seu nome"
                className="w-full border border-gray-600 rounded-lg px-4 py-2 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#cea664]"
                required
              />
            </div>

            <div>
              <label className="block text-gray-300 font-semibold mb-2">
                E-mail
              </label>
              <input
                type="email"
                name="user_email"
                placeholder="seuemail@exemplo.com"
                className="w-full border border-gray-600 rounded-lg px-4 py-2 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#cea664]"
                required
              />
            </div>

            <div>
              <label className="block text-gray-300 font-semibold mb-2">
                Mensagem
              </label>
              <textarea
                name="message"
                rows="5"
                placeholder="Digite sua mensagem..."
                className="w-full border border-gray-600 rounded-lg px-4 py-2 bg-black text-white focus:outline-none focus:ring-2 focus:ring-[#cea664]"
                required
              ></textarea>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="bg-gradient-to-r from-[#cea664] via-[#6f5431] to-[#956930] text-white font-semibold px-8 py-3 rounded-lg shadow-md hover:opacity-90 transition duration-300"
              >
                Enviar Mensagem
              </button>
            </div>
          </form>
        </div>
      </section>

      <footer className="bg-gradient-to-r from-black via-gray-900 to-black text-white py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-3 gap-10">
          <div className="text-center md:text-left space-y-2">
            <img
              src={logo}
              alt="Logo Minha Empresa"
              className="h-6 w-auto drop-shadow-md"
            />
          </div>

          <div className="text-center md:text-left space-y-2 ps-8">
            <h4 className="text-sm font-semibold text-[#cea664]  flex items-center gap-2">
              <FaMapMarkerAlt /> Endereço
            </h4>
            <p className="text-gray-400 text-sm">
              R Mal Floriano Peixoto, 460, sala 4
              <br />
              Centro - São Sebastião do Caí
              <br />
              CEP 95760-000
            </p>
          </div>

          <div className="flex justify-center md:justify-end gap-4">
            <a
              href="https://www.instagram.com/elosolucoesempresariais?igsh=MTN5eWU4Y3dqOXJleg%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-[#cea664] transition-colors"
            >
              <FaInstagram className="text-white hover:text-black" />
            </a>

            <a
              href="https://wa.me/5551999777981"
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 flex items-center justify-center rounded-full bg-gray-800 hover:bg-[#cea664] transition-colors"
            >
              <FaWhatsapp className="text-white hover:text-black" />
            </a>
          </div>
        </div>

        <div className="mt-10 border-t border-gray-700 pt-4 text-center text-sm text-gray-400">
          &copy; {new Date().getFullYear()} Elo Contabilidade - Todos os
          direitos reservados.
        </div>
      </footer>
    </div>
  );
}
